import { render, staticRenderFns } from "./ProgramLearningModuleWidget.vue?vue&type=template&id=f25f4c1c&scoped=true"
import script from "./ProgramLearningModuleWidget.vue?vue&type=script&lang=js"
export * from "./ProgramLearningModuleWidget.vue?vue&type=script&lang=js"
import style0 from "./ProgramLearningModuleWidget.vue?vue&type=style&index=0&id=f25f4c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25f4c1c",
  null
  
)

export default component.exports